import type { CurrencyAmount, Discount } from './types';

const SOURCE_LABELS: Record<string, string> = {
  volume_tier: 'Volume discount',
  pack: 'Bundle savings',
  sale: 'Sale',
  override: 'Special price',
  compare_at: 'Compare-at savings',
  subscription_perk: 'Member perk',
  coupon: 'Coupon',
  credit: 'Credits',
};

export function discountDisplayLabel(discount: Discount): string {
  if (discount.label && discount.label.trim() !== '') {
    return discount.label;
  }
  return SOURCE_LABELS[discount.source] ?? discount.source;
}

export function discountDisplayCents(discount: Discount): number {
  if (discount.amount) {
    return discount.amount.display;
  }
  return 0;
}

export function sumDiscountRowsCents(discounts: Discount[]): number {
  return discounts.reduce((sum, row) => sum + discountDisplayCents(row), 0);
}

export function flattenCartDiscountRows(input: {
  orderAppliedDiscounts?: Discount[];
  lineAppliedDiscounts?: Discount[];
}): Discount[] {
  const rows: Discount[] = [];
  if (input.lineAppliedDiscounts?.length) {
    rows.push(...input.lineAppliedDiscounts);
  }
  if (input.orderAppliedDiscounts?.length) {
    rows.push(...input.orderAppliedDiscounts);
  }
  return rows.filter((row) => discountDisplayCents(row) > 0 || (row.percent ?? 0) > 0);
}

export function pricingSavingsCents(input: {
  lineDiscounts?: CurrencyAmount;
  orderDiscounts?: CurrencyAmount;
  compareAtSubtotal?: CurrencyAmount | null;
  subtotal?: CurrencyAmount;
}): number {
  const fromTotals =
    (input.lineDiscounts?.display ?? 0) + (input.orderDiscounts?.display ?? 0);
  if (fromTotals > 0) {
    return fromTotals;
  }
  if (input.compareAtSubtotal && input.subtotal) {
    return Math.max(0, input.compareAtSubtotal.display - input.subtotal.display);
  }
  return 0;
}
